//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfList from '~/themes/fiskarsMoominDefault/components/components/organisms/SfList/SfList.vue';
import SfMegaMenu from '~/themes/fiskarsMoominDefault/components/components/organisms/SfMegaMenu/SfMegaMenu.vue';
import MoominCategoryCard from '~/themes/fiskarsMoominDefault/components/components/molecules/MoominCategoryCard/MoominCategoryCard.vue';
import SfMenuItem from '~/themes/fiskarsMoominDefault/components/components/molecules/SfMenuItem/SfMenuItem.vue';
import MoominLink from '~/themes/fiskarsMoominDefault/components/components/atoms/MoominLink/MoominLink.vue';
import MoominCharactersList from '~/themes/fiskarsMoominDefault/components/components/molecules/MoominCharactersList/MoominCharactersList.vue';

import {computed, ref, useContext} from '@nuxtjs/composition-api';


export default {
    name: "MegaMenu",
    components: {
    SfMegaMenu,
    SfList,
    MoominCharactersList,
    MoominCategoryCard,
    SfMenuItem,
    MoominLink
},
    props: {
        mobileDesign: {
          type: Boolean,
          default: false
        },
        mainMenuTitle: {
            type: String,
            default: 'Menu'
        },
        asideName: {
            type: String,
        },
        isAbsolute: {
            type: Boolean,
            default: true,
        },
        asideLink: {
            type: String
        },
        columns: {
            type: Array,
            required: true,
            default: () => [],
            validator: (columns) => {
                const keysNeeded = ['name', 'menuname', 'sublevel'];

                return columns.every(column => {
                    return keysNeeded.every(keyNeeded => {
                        return typeof column[keyNeeded] != 'undefined'
                    })
                })
            }
        },
        featuredItems: {
            type: Array,
            default: () => [],
            validator: (featuredItems) => {
                if(!featuredItems.length) return true;

                const keysNeeded = ['displayName', 'image'];

                return featuredItems.every(item => {
                    return keysNeeded.every(keyNeeded => {
                        return typeof item[keyNeeded] != 'undefined'
                    })
                })
            }
        },
        characters: {
            type: Array,
            default: () => [],
            validator: (characters) => {
                if(!characters.length) return true;

                const keysNeeded = ['characterName', 'image'];

                return characters.every(character => {
                    return keysNeeded.every(keyNeeded => {
                        return typeof character[keyNeeded] != 'undefined'
                    })
                })
            }
        },
    },
    setup(props, { emit }) {
        let activeColumn = ref('');
        const { localePath } = useContext();
        const emitClose = () => emit('close');
        const setActiveColumn =  (section) => activeColumn.value = section;
        const returnLink = (item, isDesktop) => isDesktop || !props.mobileDesign ? localePath(item?.link?.href) : item?.sublevel.length ? '' : localePath(item?.link?.href);
        const selectCharacter =  (emitClose) => {
          if(emitClose) emitClose();
        }
        const linkClicked = (item, isDesktop) => {
            if(returnLink(item, isDesktop))
                emitClose()
        }

        const _asideType = computed (() => props.asideName);
        const _noLevel3 = computed(() => props.columns.every(column => !column.sublevel || !column.sublevel.length));

        return {
            selectCharacter,
            setActiveColumn,
            _asideType,
            _noLevel3,
            activeColumn,
            returnLink,
            linkClicked,
            emitClose
        }
    }
};
